module.exports = __webpack_public_path__ + "prod/1.42.2/img/renshi-three.50f89317.png";